import theme from '@app/ui/theme'
import styled from 'styled-components'

const indicatorSize = 8

export const UserColorIndicator = styled.div<{
  userColor?: string
  zIndex: number
  size: number
}>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  background-color: ${({ userColor }) => userColor};
  border: 2px solid ${theme.colors.white};
  border-radius: 500px;
  top: 0;
  right: -2px;
  position: absolute;
  z-index: ${({ zIndex }) => zIndex + 1};
`

export const AvatarContainer = styled.div<{
  userColor?: string
  isLastIndex?: boolean
  avatarSize: number
}>`
  height: ${({ avatarSize }) => avatarSize}px;
  width: ${({ avatarSize }) => avatarSize}px;
  background-color: ${({ userColor }) => userColor};
  border: 3px solid white;
  border-radius: 500px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 45%), 0 1px 3px rgb(0 0 0 / 30%);
  opacity: ${({ isLastIndex }) => (isLastIndex ? 1 : 0.7)};
  margin-left: ${({ isLastIndex }) => (!isLastIndex ? -8 : 0)}px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ImgContainer = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 500px;
`

export const AvatarText = styled.span<{
  size: number
}>`
  font-size: ${({ size }) => size - 4}px;
  font-weight: 800;
  color: white;
`

export const OuterContainer = styled.div<{
  zIndex: number
}>`
  position: relative;
  zindex: ${({ zIndex }) => zIndex}px;
`

export const PopoverWrapper = styled.div`
  position: relative;
  cursor: pointer;
`

export const Popover = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: white;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgb(0 0 0 / 18%), 0 2px 8px rgb(0 0 0 / 10%);
  padding: 14px 16px;
  min-width: 200px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: popover-in 0.15s ease;
  @keyframes popover-in {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const PopoverName = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #222;
`

export const PopoverDivider = styled.hr`
  border: none;
  border-top: 1px solid #eee;
  margin: 0;
`

export const PopoverRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #555;
`

export const PopoverLabel = styled.span`
  font-weight: 600;
  color: #888;
  min-width: 40px;
`

export const PopoverColorDot = styled.div<{ color?: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ color }) => color ?? '#ccc'};
  border: 1px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
`

export const PopoverRoleBadge = styled.span<{ $role: number }>`
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  background-color: ${({ $role }) => {
    switch ($role) {
      case 0: return '#e8f4fd'
      case 1: return '#fef3e2'
      case 2: return '#edf7ed'
      default: return '#f0f0f0'
    }
  }};
  color: ${({ $role }) => {
    switch ($role) {
      case 0: return '#1a73e8'
      case 1: return '#f09300'
      case 2: return '#2e7d32'
      default: return '#888'
    }
  }};
`
